export enum UniversalAddTrackingEventNames {
    PickType = "universal_add_pick_type",
    SnippetsComplete = "snippet_fetch_completed",
    FindUserComplete = "user_find_completed",
    CreateSource = "universal_add_user_creates_source",
    ItemAdded = "universal_add_item_added",
    DuplicateFound = "universal_add_duplicate_found",
    DuplicateReplaced = "universal_add_duplicate_replaced",
}

export enum UniversalAddPickType {
    Articles = "Articles",
    Podcasts = "Podcasts",
    Video = "Video",
    SocialMedia = "SocialMedia",
    PDFs = "PDFs",
    ScreenshotPictures = "ScreenshotPictures",
    Other = "Other",
    Image = "Image",
    Book = "Book",
}

export enum ManualImportPathTaken {
    Articles = "Articles",
    VideosOther = "VideosOther",
    YoutubeOther = "YoutuberOther",
    Other = "Other",
    PodcastEpisode = "PodcastEpisode",
    SocialMedia = "SocialMedia",
    PDFs = "PDFs",
    WebsiteScreenshot = "WebsiteScreenshot",
    AddSourceRejected = "AddSourceRejected",
    AddSourceNonBylinedContent = "AddSourceNonBylinedContent",
    AddSourceSomethingElse = "AddSourceSomethingElse",
    Image="Image",
    Book = "Book",
}